var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11L21 6V18L3 14V11Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5997 16.8C11.4947 17.1808 11.3156 17.5372 11.0728 17.8488C10.83 18.1605 10.5282 18.4212 10.1847 18.6162C9.84108 18.8112 9.46245 18.9367 9.07041 18.9853C8.67836 19.034 8.28056 19.005 7.89973 18.9C7.51889 18.7949 7.16248 18.6159 6.85084 18.3731C6.5392 18.1303 6.27844 17.8285 6.08343 17.4849C5.88843 17.1413 5.76301 16.7627 5.71433 16.3706C5.66565 15.9786 5.69467 15.5808 5.79973 15.2",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavCampaign);
export default __webpack_public_path__ + "static/media/icon-nav-campaign.1ea642545413d6d49e170a4152698882.svg";
export { ForwardRef as ReactComponent };